module.exports = __webpack_public_path__ + "media/images/official/event_bg-adc0df2cdb085470a631b5ce9c2a0307.jpg";